module.exports = __webpack_public_path__ + "KMProna-Budyne.jpg?840fac843d7cf12e78e26ab9ca3c0ffb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/KMProna-Budyne.jpg
// module id = 240
// module chunks = 0